<div class="row">
  <div class="col">
    <rask-textarea
      aid="atgAnteckning"
      class="w-100"
      label="Anteckning till avverkningsdirektiv"
      [rows]="3"
      [(ngModel)]="selectedAtgard.anteckningProduktionsplanering"
      (change)="updateAtgAnteckningProduktionsplanering()"
      [disabled]="!isDetailEditable()"
      [maxlength]="50">
    </rask-textarea>
  </div>
</div>
@if (selectedAtgard.uttagsanvisning) {
  <div class="row mt-3">
    <div class="col">
      <rask-textmultiline label="Uttagsanvisning" [value]="selectedAtgard.uttagsanvisning"></rask-textmultiline>
    </div>
  </div>
}